import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Typography from "../../typography";
import { Colors } from "../../../utils/colors";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "./style.css";
import DateConvert from "../../../utils/dateConvert";

interface IProps {
  label?: string;
  placeholder?: string;
  selectDate?: (date: Date | null) => void;
  minDate?: Date | null;
  maxDate?: Date | null;
  initialDate?: Date | null;
  disabled?: boolean;
}

const DateInput = ({
  label = "date",
  placeholder,
  selectDate,
  minDate,
  maxDate,
  disabled,
  initialDate = null
}: IProps) => {
  const [date, setDate] = useState<Date | null>(initialDate);
  const datePickerRef = useRef<any>(null);

  const handleButtonClick = () => {
    datePickerRef.current?.setOpen(true);
  };

  useEffect(() => {
    setDate(initialDate);
  }, [initialDate]);
  return (
    <Container>
      <Typography color={Colors.grey400} mb="0.4">
        {label}
      </Typography>
      <Main>
        <InputContainer>
          <DatePicker
            ref={datePickerRef}
            selected={date}
            disabled={disabled}
            onChange={(date) => {
              setDate(date);
              if (selectDate) {
                selectDate(date);
              }
            }}
            maxDate={maxDate ? maxDate : undefined}
            startDate={new Date()}
            minDate={minDate ? minDate : undefined}
          />
        </InputContainer>
        <Body onClick={handleButtonClick}>
          <Typography color={Colors.grey400}>
            {date ? DateConvert(date) : placeholder}
          </Typography>
          <CalendarIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M1.5 9C1.5 6.17157 1.5 4.75736 2.37868 3.87868C3.25736 3 4.67157 3 7.5 3H10.5C13.3284 3 14.7427 3 15.6213 3.87868C16.5 4.75736 16.5 6.17157 16.5 9V10.5C16.5 13.3284 16.5 14.7427 15.6213 15.6213C14.7427 16.5 13.3284 16.5 10.5 16.5H7.5C4.67157 16.5 3.25736 16.5 2.37868 15.6213C1.5 14.7427 1.5 13.3284 1.5 10.5V9Z"
                stroke="#CDCDCD"
                stroke-width="1.125"
              />
              <path
                d="M5.25 3V1.875"
                stroke="#CDCDCD"
                stroke-width="1.125"
                stroke-linecap="round"
              />
              <path
                d="M12.75 3V1.875"
                stroke="#CDCDCD"
                stroke-width="1.125"
                stroke-linecap="round"
              />
              <path
                d="M6.75 10.875L7.875 9.75V12.75"
                stroke="#CDCDCD"
                stroke-width="1.125"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.75 12V10.5C9.75 10.0858 10.0858 9.75 10.5 9.75C10.9142 9.75 11.25 10.0858 11.25 10.5V12C11.25 12.4142 10.9142 12.75 10.5 12.75C10.0858 12.75 9.75 12.4142 9.75 12Z"
                stroke="#CDCDCD"
                stroke-width="1.125"
                stroke-linecap="round"
              />
              <path
                d="M1.875 6.75H16.125"
                stroke="#CDCDCD"
                stroke-width="1.125"
                stroke-linecap="round"
              />
            </svg>
          </CalendarIcon>
        </Body>
      </Main>
    </Container>
  );
};

export default DateInput;

const Container = styled.div`
  width: 100%;
`;

const Main = styled.div`
  position: relative;
`;
const Body = styled.div`
  width: 100%;
  border-radius: 0.8rem;
  border: 1px solid ${Colors.grey600};
  padding: 0.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CalendarIcon = styled.div`
  width: 1.8rem;
`;

const InputContainer = styled.div`
  position: absolute;
  cursor: pointer;
  z-index: 10;
  font-size: 1.4rem;
  top: 50%;
  left: 50%;
  opacity: 1;
  transform: translate(-50%, -50%);
`;
